import React, { Fragment } from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { GAME_RULES_HELP_KEYS } from '../../enums/constants';
import img10 from '../../assets/images/help/img10.png';
import img13 from '../../assets/images/help/img13.png';
import img15 from '../../assets/images/help/img15.png';
import img16 from '../../assets/images/help/img16.png';
import img17 from '../../assets/images/help/img17.png';
import img18 from '../../assets/images/help/img18.png';
import img19 from '../../assets/images/help/img19.png';
import img20 from '../../assets/images/help/img20.png';
import img21 from '../../assets/images/help/img21.png';
import img22 from '../../assets/images/help/img22.png';
import img23 from '../../assets/images/help/img23.png';
import img24 from '../../assets/images/help/img24.png';

const sortedImages = {
  9: img10,
  12: img13,
  14: img15,
  15: img16,
  16: img17,
  17: img18,
  18: img19,
  19: img20,
  20: img21,
  21: img22,
  22: img23,
  23: img24,
};

const titles = [];

export function HelpPopup() {
  const t = useTranslation();

  return (
    <div className='game-rules-holder'>
      {GAME_RULES_HELP_KEYS.map((item) => (
        <Fragment key={item}>
          <p
            key={item}
            className={`game-rules-txt ${titles.includes(item) ? 'game-rules-txt-title' : ''}`}
          >
            {t(`GAME_RULES_P${item + 1}`)}
          </p>
          {!!sortedImages?.[item] && (
            <div className='game-rules-image-holder'>
              <img src={sortedImages?.[item]} alt='help-field' />
            </div>
          )}
        </Fragment>
      ))}
      <p className='game-rules-txt'>RTP: 96%</p>
    </div>
  );
}
